import React from 'react';

type TooltipProps = {
  tooltipText: string;
  width?: string;
  position?: 'left' | 'right';
};

export default function Tooltip({ tooltipText, width, position = 'left' }: TooltipProps) {
  const positionClass = position === 'right' ? 'right-0' : 'left-0';
  return (
    <div className={`absolute bottom-6 ${positionClass} ${width ? width : 'w-auto'} bg-blue-200 p-2 rounded-md z-[9999] flex justify-center items-center transition-opacity`}>
      <p className="text-sm text-gray-700 text-center">{tooltipText}</p>
    </div>
  );
}
